import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { installErrorReporting, reportClientError } from "./lib/clientErrors";
import "./styles.css";

installErrorReporting();

createRoot(document.getElementById("root")!, {
  onUncaughtError: (error) => reportClientError(error, "react-uncaught"),
  onCaughtError: (error) => reportClientError(error, "react-caught"),
}).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
